import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgForm } from '@angular/forms';
import { Store } from '@ngrx/store';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { combineLatest, Observable, Subject, Subscription } from 'rxjs/index';
import { map } from 'rxjs/operators';
import { BsModalConfirmComponent, createConfirmModalOptions } from '../../core/modal/modal-confirm.component';
import { AppointmentListActions } from '../appointment-list/state/appointment-list.actions';
import { AppointmentSettingsActions } from './state/appointment-settings.actions';
import { AppointmentSettingsSelectors } from './state/appointment-settings.selectors';
import { AuthenticationSelectors } from '../../auth/state/authentication.selectors';
import { AppointmentListSelectors } from '../appointment-list/state/appointment-list.selectors';

@Component({
    selector: 'appointment-settings',
    templateUrl: './appointment-settings.component.html'
})
export class AppointmentSettingsComponent implements OnInit {

    constructor(public appointmentSettingsSelector: AppointmentSettingsSelectors,
                public appointmentSettingsBsModalRef: BsModalRef,
                private authenticationSelectors: AuthenticationSelectors,
                private appointmentsListSelectors: AppointmentListSelectors,
                private modalService: BsModalService,
                private store: Store<any>,
                private formBuilder: FormBuilder) {

        this.displayBirthday$ = this.appointmentSettingsSelector.selectDisplayBirthday();
        this.displayTwoway$ = this.appointmentSettingsSelector.selectDisplayTwoway();
        this.displayIncorrectDestinator$ = this.appointmentSettingsSelector.selectDisplayIncorrectDestinator();
        this.loading$ = this.appointmentSettingsSelector.selectLoading();
        this.isAuthenticatedFromAdmin$ = this.authenticationSelectors.selectIsAuthenticatedFromAdmin();
        this.viewDeletedReminders$ = this.appointmentsListSelectors.selectViewDeletedReminder();
        this.viewVoidAppointments$ = this.appointmentsListSelectors.selectViewVoidAppointments();
        this.showProviders$ = this.appointmentSettingsSelector.selectShowProviders();
    }

    formGroup: FormGroup;
    displayBirthday$: Observable<boolean>;
    displayTwoway$: Observable<boolean>;
    loading$: Observable<boolean>;
    displayIncorrectDestinator$: Observable<boolean>;
    appointmentSettingModel$: Observable<any>;
    onClose: Subject<boolean>;
    isAuthenticatedFromAdmin$: Observable<boolean>;
    viewDeletedReminders$: Observable<boolean>;
    viewVoidAppointments$: Observable<boolean>;
    showProviders$: Observable<boolean>;

    ngOnInit(): void {
        this.onClose  = new Subject();
        this.appointmentSettingModel$ = combineLatest(
            [
                this.displayBirthday$,
                this.displayTwoway$,
                this.displayIncorrectDestinator$,
                this.viewDeletedReminders$,
                this.viewVoidAppointments$,
                this.showProviders$
            ]
        )
            .pipe(
                map(([displayBirthday, displayTwoway, displayIncorrectDestinator, viewDeletedReminders, viewVoidAppointments, showProviders]) => {
                    this.formGroup = this.formBuilder.group({
                        enableBirthday: [displayBirthday],
                        enableTwoway: [displayTwoway],
                        enableIncorrectDestinator: [displayIncorrectDestinator],
                        enableProviders: showProviders,
                        viewDeleted: [viewDeletedReminders],
                        viewVoid: [viewVoidAppointments]
                    });

                    return ({displayBirthday, displayTwoway, displayIncorrectDestinator, viewDeletedReminders, viewVoidAppointments});
                })
            );

    }

    public onCancel(): void {
        if (this.formGroup.dirty) {
            const modalRef = this.modalService
                .show(BsModalConfirmComponent, createConfirmModalOptions('Confirm',
                    'You will loose all unsaved changes. Are you sure you want to exit?',
                    'Yes', 'No'));

            modalRef.content.onClose
                .subscribe(dialogResult => {
                    if (dialogResult.isConfirmed) {
                        this.formGroup.markAsPristine();
                        this.appointmentSettingsBsModalRef.hide();
                        this.onClose.next(dialogResult);
                    }
                });
        } else {
            this.appointmentSettingsBsModalRef.hide();
        }
    }

    updateAppointmentSettings(): void {

        this.store.dispatch(AppointmentSettingsActions
            .saveAppointmentSettings({ displayBirthday: this.formGroup.controls['enableBirthday'].value || false,
                                       displayTwoway: this.formGroup.controls['enableTwoway'].value || false,
                                       displayIncorrectDestinator: this.formGroup.controls['enableIncorrectDestinator'].value || false,
                                       showProviders: this.formGroup.controls['enableProviders'].value || false }));
        const isDeleted = this.formGroup.controls['viewDeleted'].value || false;
        this.store.dispatch(AppointmentListActions.setViewDeletedReminders({payload: isDeleted}));
        const isVoid = this.formGroup.controls['viewVoid'].value || false;
        this.store.dispatch(AppointmentListActions.setViewVoidAppointments({payload: isVoid}));

        // Once save is successful close the pop up
        this.loading$.subscribe(
            loading => {
                if (!loading) {
                    this.appointmentSettingsBsModalRef.hide();
                }
            }
        );

    }
}
